import {Component, computed, input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-lib-progress-bar',
  imports: [],
  templateUrl: './progress-bar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './progress-bar.component.css'
})
export class ProgressBarComponent {

  value = input.required<number>();
  max = input.required<number>();
  protected progress = computed(() => {
    const value = this.value();
    const max = this.max();
    return value / max * 100;
  })
  indeterminate = input(false);

}
